// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2tmfd","additionalInfo":"AgreementModal_additionalInfo__1F3Tj"};